import { useTranslation } from "next-i18next"

const useRegisterOfflineProducti18n = ({
  authorData: {
    backToMyProducts,
    registerProductsTitle,
    productInfoDescription,
    address,
    addComment,
    addAnotherProductToRegister,
    reviewAnswer,
    submitRegistration,
    confirmationMainCopy,
    confirmationSubCopy,
    productRegistered,
    whereToFind,
    kohler,
    sterlingProduct,
    productLabel,
    productLiterature,
    invoice,
    stamped,
    troubleShooting,
    serialNumberPlaceholder,
  } = {},
}) => {
  const { t } = useTranslation()
  const i18n = {
    backToMyProducts:
      backToMyProducts ?? t("kf.registerOfflineProduct.label.backToMyProducts"),
    registerProductsTitle:
      registerProductsTitle ??
      t("kf.registerOfflineProduct.label.registerProductsTitle"),
    productInfoDescription:
      productInfoDescription ??
      t("kf.registerOfflineProduct.label.productInfoDescription"),
    requiredFields: t("kf.registerOfflineProduct.label.requiredFields"),
    productInformationTitle: t(
      "kf.registerOfflineProduct.label.productInformationTitle"
    ),
    modelNumber: t("kf.registerOfflineProduct.label.modelNumber"),
    serialNumber: t("kf.registerOfflineProduct.label.serialNumber"),
    serialNumberOptional:
      serialNumberPlaceholder ??
      t("kf.registerOfflineProduct.label.serialNumberOptional"),
    placeOfPurchase: t("kf.registerOfflineProduct.label.placeOfPurchase"),
    productDetails: t("kf.registerOfflineProduct.label.productDetails"),
    datePurchase: t("kf.registerOfflineProduct.label.datePurchase"),
    dealerName: t("kf.registerOfflineProduct.label.dealerName"),
    getOTP: t("kf.registerOfflineProduct.label.getOTP"),
    mobileVerified: t("kf.registerOfflineProduct.label.mobileVerified"),
    verifyMobile: t("kf.registerOfflineProduct.label.verifyMobile"),
    registerMobile: t("kf.registerOfflineProduct.label.registerMobile"),
    pinCode: t("kf.registerOfflineProduct.label.pinCode"),
    countryCode: t("kf.registerOfflineProduct.label.countryCode"),
    emailAddress: t("kf.registerOfflineProduct.label.email"),
    modelNumberSupportLink: t(
      "kf.registerOfflineProduct.label.modelNumberSupportLink"
    ),
    registrationInformationTitle: t(
      "kf.registerOfflineProduct.label.registrationInformationTitle"
    ),
    firstName: t("kf.registerOfflineProduct.label.firstName"),
    lastName: t("kf.registerOfflineProduct.label.lastName"),
    address: address ?? t("kf.registerOfflineProduct.label.address"),
    city: t("kf.registerOfflineProduct.label.city"),
    state: t("kf.registerOfflineProduct.label.state"),
    zipCode: t("kf.registerOfflineProduct.label.zipCode"),
    installationDate: t("kf.registerOfflineProduct.label.installationDate"),
    addComment: addComment ?? t("kf.registerOfflineProduct.label.addComment"),
    next: t("kf.registerOfflineProduct.label.next"),
    save: t("kf.registerOfflineProduct.label.save"),
    addAnotherProductToRegister:
      addAnotherProductToRegister ??
      t("kf.registerOfflineProduct.label.addAnotherProductToRegister"),
    reviewTitle: t("kf.registerOfflineProduct.label.reviewTitle"),
    reviewQuestion: t("kf.registerOfflineProduct.label.reviewQuestion"),
    reviewAnswer: reviewAnswer,
    termCondition1: t("kf.registerOfflineProduct.label.termsCondition1"),
    termCondition2: t("kf.registerOfflineProduct.label.termsCondition2"),
    terms: t("kf.registerOfflineProduct.label.terms"),
    policy: t("kf.registerOfflineProduct.label.policy"),
    submitRegistration:
      submitRegistration ??
      t("kf.registerOfflineProduct.label.submitRegistration"),
    confirmationMainCopy: productLength =>
      confirmationMainCopy ??
      t("kf.registerOfflineProduct.label.confirmationMainCopy", {
        productCount: productLength,
      }),
    confirmationSubCopy:
      confirmationSubCopy ??
      t("kf.registerOfflineProduct.label.confirmationSubCopy"),
    reviewProducts: t("kf.registerOfflineProduct.label.reviewProducts"),
    productRegistrationSummary: t(
      "kf.registerOfflineProduct.label.productRegistrationSummary"
    ),
    productRegistered:
      productRegistered ??
      t("kf.registerOfflineProduct.label.productRegistered"),
    backToHome: t("kf.registerOfflineProduct.label.backToHome"),
    mobileNumberError: t("kf.registerOfflineProduct.label.mobileNumberError"),
    mobileNumberValid: t(
      "kf.registerOfflineProduct.label.mobileValidNumberError"
    ),
    firstNameError: t("kf.registerOfflineProduct.label.firstNameError"),
    lastNameError: t("kf.registerOfflineProduct.label.lastNameError"),
    emailError: t("kf.registerOfflineProduct.label.emailError"),
    emailValidError: t("kf.registerOfflineProduct.label.emailValidError"),
    addressError: t("kf.registerOfflineProduct.label.addressError"),
    cityError: t("kf.registerOfflineProduct.label.cityError"),
    stateError: t("kf.registerOfflineProduct.label.stateError"),
    zipCodeError: t("kf.registerOfflineProduct.label.zipCodeError"),
    pinCodeError: t("kf.registerOfflineProduct.error.pinCodeError"),
    pinCodeValidError: t(
      "kf.registerOfflineProduct.label.pincodeValidNumberError"
    ),
    validZipcode: t("kf.registerOfflineProduct.label.validZipcode"),
    modelNumberError: t("kf.registerOfflineProduct.label.modelNumberError"),
    validModelNumberError: t(
      "kf.registerOfflineProduct.label.modelNumberError"
    ),
    serialNumberError: t("kf.registerOfflineProduct.label.serialNumberError"),
    validSerialNumberError: t(
      "kf.registerOfflineProduct.label.validSerialNumberError"
    ),
    placeOfPurchaseError: t(
      "kf.registerOfflineProduct.label.placeOfPurchaseError"
    ),
    remove: t("kf.registerOfflineProduct.label.remove"),
    dateOfInstallation: t("kf.registerOfflineProduct.label.dateOfInstallation"),
    drag: t("kf.registerOfflineProduct.label.drag"),
    drop: t("kf.registerOfflineProduct.label.drop"),
    or: t("kf.registerOfflineProduct.label.or"),
    uploadPhoto: t("kf.registerOfflineProduct.label.uploadPhoto"),
    addPhoto: t("kf.registerOfflineProduct.label.addPhoto"),
    whereToFind:
      whereToFind ?? t("kf.registerOfflineProduct.label.whereToFind"),
    kohler: kohler ?? t("kf.registerOfflineProduct.label.kohler"),
    sterlingProduct:
      sterlingProduct ?? t("kf.registerOfflineProduct.label.sterlingProduct"),
    yourorder: t("kf.registerOfflineProduct.label.yourorder"),
    productLabel:
      productLabel ?? t("kf.registerOfflineProduct.label.productLabel"),
    productLiterature:
      productLiterature ??
      t("kf.registerOfflineProduct.label.productLiterature"),
    invoice: invoice ?? t("kf.registerOfflineProduct.label.invoice"),
    stamped: stamped ?? t("kf.registerOfflineProduct.label.stamped"),
    troubleShooting:
      troubleShooting ?? t("kf.registerOfflineProduct.label.troubleShooting"),
    uploadLimitError: t(
      "kf.registerOfflineProduct.error.imageUploadMaxFilesExceed"
    ),
    uploadFileSizeError: t(
      "kf.registerOfflineProduct.error.imageUploadMaxFileSizeExceed"
    ),
    provideImageError: t("kf.registerOfflineProduct.error.provideImageError"),
    uploadFileTypeError: t(
      "kf.registerOfflineProduct.error.imageUploadFileTypes"
    ),
    validDateError: t("kf.registerOfflineProduct.label.validDateError"),
    maxDateError: t("kf.registerOfflineProduct.label.maxDateError"),
    serverError: t("kf.registerOfflineProduct.error.serverError"),
    siteLabel: t("kf.registerOfflineProduct.label.site"),
    productError: t("kf.registerOfflineProduct.error.productError"),
    dateOfPurchaseError: t(
      "kf.registerOfflineProduct.error.dateOfPurchaseError"
    ),
    ariaLabel: {
      imageRemove: t("kf.registerOfflineProduct.label.aria.removeImage"),
      next: t("kf.registerOfflineProduct.label.aria.next"),
      removeEmpty: t("kf.registerOfflineProduct.label.aria.removeEmpty"),
      removeProduct: model =>
        t("kf.registerOfflineProduct.label.aria.removeProduct", { model }),
    },
    genericError: t("kf.error.message.genericError"),
  }

  return i18n
}

export default useRegisterOfflineProducti18n
